import AlertFilled from "chameleon/icons/alert-filled";
import { Text } from "chameleon/lib/components";

import { card, cardParent, content } from "./error-tile.css";

export const ErrorTile = ({
  title = "The form could not be displayed",
  caption = "You may refresh the page or try again later.",
}: {
  title?: string;
  caption?: string;
}) => {
  return (
    <div className={cardParent}>
      <div className={card}>
        <div className={content}>
          <AlertFilled sizeVariant={60} color={"critical"} />
          <Text styleVariant={"heading2"} colorVariant={"primaryText"}>
            {title}
          </Text>
          <Text styleVariant={"body"} colorVariant={"secondaryText"}>
            {caption}
          </Text>
        </div>
      </div>
    </div>
  );
};
